import authSagas from "./auth";
import userManagementSaga from "./userManagement";
import settingsSagas from "./settings";
import alertsSaga from "./alerts";
import accountSagas from "./account";
import loanSagas from "./loan";
import investorTrackerSagas from "./investorTracker";
import businessTrackerSagas from "./businessTracker";
import apiSagas from "./api";

const sagas = [
  authSagas,
  userManagementSaga,
  settingsSagas,
  alertsSaga,
  accountSagas,
  loanSagas,
  investorTrackerSagas,
  businessTrackerSagas,
  apiSagas,
]

const registerSagas = (middleware) => {
  sagas.forEach((saga) => {
    middleware.run(saga)
  })
}

export default registerSagas;